import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { IId, TNameTitle } from '@interfaces/common/common';
import { IGroupOperationDTO } from '@interfaces/common/defaultDTO';
import { IDownloadUrl } from '@interfaces/common/file';
import { IItemsResponse } from '@interfaces/common/response';
import {
	IDownloadHistoryDTO,
	IDownloadHistoryFilterDTO,
	IDownloadHistoryItem,
} from '@interfaces/downloadHistory/downloadHistoryDTO';

const {
	downloadHistory,
} = URL;

export const getDownloadHistory = (
	dto: IDownloadHistoryDTO,
): Promise<IItemsResponse<IDownloadHistoryItem>> => {
	return client.get(downloadHistory, {
		params: dto,
	});
};

export const removeDownloadHistoryFiles = ({
	filter,
	ids,
	isAll,
}: IGroupOperationDTO<IDownloadHistoryFilterDTO | null>): Promise<void> => {
	return client.post(`${downloadHistory}/delete-many`, {
		filter,
		ids,
		isAll,
	});
};

export const removeDownloadHistoryFile = ({ id }: IId): Promise<void> => {
	return client.delete(`${downloadHistory}/${id}`);
};

export const exportDownloadHistoryFiles = ({
	filter,
	ids,
	isAll,
}: IGroupOperationDTO<IDownloadHistoryFilterDTO | null>): Promise<IDownloadUrl> => {
	return client.post(`${downloadHistory}/download-many`, 	{
		filter,
		ids,
		isAll,
	});
};

export const exportDownloadHistoryFile = ({ id }: IId): Promise<IDownloadUrl> => {
	return client.get(`${downloadHistory}/download-url/`, {
		params: {
			id,
		},
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const getDownloadHistorySources = (): Promise<TNameTitle[]> => {
	return client.get(`${downloadHistory}/sources`);
};

export const getDownloadHistoryStatuses = (): Promise<TNameTitle[]> => {
	return client.get(`${downloadHistory}/statuses`);
};
